import { render, staticRenderFns } from "./PageEditorLeftSidebar.vue?vue&type=template&id=528df67b&scoped=true"
import script from "./PageEditorLeftSidebar.vue?vue&type=script&lang=js"
export * from "./PageEditorLeftSidebar.vue?vue&type=script&lang=js"
import style0 from "./PageEditorLeftSidebar.vue?vue&type=style&index=0&id=528df67b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "528df67b",
  null
  
)

export default component.exports